/**
 * @ngdoc function
 * @name lmApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the lmApp
 */
lmApp.controller('NPVRController', ['$routeParams', '$location', '$q', '$templateCache', '$compile', '$scope', '$rootScope', 'ToastService', 'SubscriberResource', 'DVRTasksResource', 'ModalWindowService', 'ManagerResource', 'TimezoneService', 'SubscriberV2Service', 'DVRTaskService',
    function ($routeParams, $location, $q, $templateCache, $compile, $scope, $rootScope, ToastService, SubscriberResource, DVRTasksResource, ModalWindowService, ManagerResource, TimezoneService, SubscriberV2Service, DVRTaskService) {
        $scope.loading = false;
        $scope.records = [];
        $scope.subscribers = [];
        $scope.isAllSelected = false;

        // Timezone
        var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
        $scope.tz = timezone.title;
        ManagerResource.get().$promise
            .then(function (result) {
                if (result.length !== 0) {
                    var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
                    if (manager) {
                        timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
                        $scope.tz = timezone.title;
                    }
                }
            })
            .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
            });

        $scope.convertTime = function (dt) {
            return TimezoneService.addTimezoneToDate(dt, timezone)
        };

        //
        $scope.collectionData = {
            filters: {
                subscribers: [],
                sortBy: '-create_time'
            },
            offset: 0,
            limit: 20,
            isStart: function () {
                return $scope.routePage === 1;
            },
            isEnd: false,
            nextPage: function () {
                if (this.isEnd || $scope.loading) return;
                $scope.routePage = $scope.routePage + 1;
                $location.search('page', $scope.routePage);
                this.offset += $scope.collectionData.limit;
                $scope.isAllSelected = false;
                $scope.getRecords();
            },
            prevPage: function () {
                if (this.isStart()) return;
                if (this.offset >= this.limit) {
                    this.offset -= this.limit;
                    $scope.routePage = $scope.routePage - 1;
                    $location.search('page', $scope.routePage);
                } else {
                    this.offset = 0;
                    $scope.routePage = 1;
                    $location.search('page', 1);
                }
                $scope.isAllSelected = false;
                $scope.getRecords();
            }
        };

        if ($scope.subscribers.length === 0) {
            SubscriberResource.get().$promise
                .then(function (result) {
                    $scope.subscribers = (result.data || []).map(function (subscriber) {
                        return {
                            id: subscriber.id,
                            title: subscriber.username
                        }
                    });
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                        color: 'amber',
                        icon: 'server-off',
                        blocked: true
                    }, 1000 * 3);
                });
        }

        $scope.stat = [];
        $scope.getStatData = function() {
            var params = {};
            params['$limit'] = 5000;
            params['$offset'] = 0;
            params['$orderby'] = '-create_time';
            DVRTasksResource.list(params).$promise
                .then(function (result) {
                    var records = (result.data || []);
                    var stat = {};
                    var allKeys = [];
                    if (records.length) {
                        for (var i = 0; i < records.length; i++) {
                            var r = records[i];
                            var parts = r.start_time.split('T');
                            var key = moment(parts[0] + 'T00:00:00Z').unix();
                            if (!stat.hasOwnProperty(key)) {
                                allKeys.push(key);
                                stat[key] = {
                                    label: moment(r.start_time).utc().format('D MMM'),
                                    pending: 0,
                                    scheduled: 0,
                                    recording: 0,
                                    recorded: 0,
                                    error: 0
                                }
                            }
                            switch (r.state) {
                                case 'pending':
                                    stat[key].pending += 1;
                                    break;
                                case 'scheduled':
                                    stat[key].scheduled += 1;
                                    break;
                                case 'recording':
                                    stat[key].recording += 1;
                                    break;
                                case 'recorded':
                                    stat[key].recorded += 1;
                                    break;
                                case 'error':
                                    stat[key].error += 1;
                            }
                        }
                    }
                    allKeys.sort(function(a, b) { return b-a });
                    var statArr = [];
                    for (var i = 0; i < allKeys.length; i++) {
                        if (i >= 20) break;
                        var s = stat[allKeys[i]];
                        statArr.push({
                            label: s.label,
                            pending: s.pending,
                            scheduled: s.scheduled,
                            recording: s.recording,
                            recorded: s.recorded,
                            error: s.error
                        });
                    }
                    $scope.stat = statArr.reverse();
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason, 'silent');
                })
        };

        $scope.displayStat = false;
        $scope.toggleStat = function() {
            if ($scope.stat.length === 0) return;
            $scope.displayStat = !$scope.displayStat;
        };

        $scope.getRecords = function () {
            if ($scope.loading) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#npvrLoader');

            $scope.collectionData.isEnd = false;

            var params = {};
            params['$limit'] = $scope.collectionData.limit + 1;
            params['$offset'] = $scope.collectionData.offset;
            params['$orderby'] = $scope.collectionData.filters.sortBy;

            if ($scope.collectionData.filters.subscribers.length > 0) {
                var id = [];
                $scope.collectionData.filters.subscribers.forEach(function (s) { id.push(s.id) });
                params['subscribers.id[in]'] = id.join(',')
            }

            DVRTasksResource.get(params).$promise
                .then(function (result) {
                    var records = (result.data || []);
                    if (records.length < $scope.collectionData.limit + 1) {
                        $scope.collectionData.isEnd = true;
                    } else {
                        records.pop();
                    }

                    $scope.records = records.map(function (record, i) {
                            record._subscriber_ext_id = "N/A";
                            if (record.subscriber) {
                                record._subscriber_ext_id = record.subscriber.username;
                            }
                            record._program_name = "N/A";
                            record._program_description = "N/A";
                            if (record.program) {
                                record._program_name = record.program.name;
                                record._program_description = record.program.description;
                            }
                            record._channel_logo_URL = '';
                            record._channel_name = '';
                            if (record.live) {
                                record._channel_logo_URL = _.get(_.find(record.live.resources, {type: 'picture', category: 'poster_blueprint'}), 'source', '');
                                record._channel_name = record.live.name;
                            }
                            record.size = record.size || 0;
                            if (record.size > 0) {
                                record.size = (record.size / 1024 / 1024).toFixed();
                            }
                            record.selected = false;
                            return record;
                        });
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#npvrLoader');

                    if ($scope.records.length === 0 && $scope.routePage !== 1) {
                        $scope.collectionData.offset = 0;
                        $scope.routePage = 1;
                        $location.search('page', 1);
                        $scope.getRecords();
                    }
                })
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#npvrLoader');
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                        title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                        color: 'amber',
                        icon: 'server-off',
                        blocked: true
                    }, 1000 * 3);
                })
        };

        $scope.toggleAll = function () {
            angular.forEach($scope.records, function(r){ r.selected = $scope.isAllSelected; });
        };

        $scope.Filter = function () {
            $scope.collectionData.offset = 0;
            $scope.isAllSelected = false;
            $scope.routePage = 1;
            $location.search('page', 1);
            $scope.getRecords();
        };

        $scope.SetOrder = function (field) {
            if (!$scope.records.length) return;

            if (field === $scope.collectionData.filters.sortBy) {
                $scope.collectionData.filters.sortBy = '-' + $scope.collectionData.filters.sortBy;
            } else {
                $scope.collectionData.filters.sortBy = field
            }
            $scope.collectionData.offset = 0;
            $scope.isAllSelected = false;
            $scope.routePage = 1;
            $location.search('page', 1);
            $scope.getRecords();
        };

        $scope.RemoveSelectedRecords = function () {
            if ($scope.loading) return;

            var ids = [];
            angular.forEach($scope.records, function(record, index) {
                if (record.selected) {
                    ids.push(record.id);
                }
            });

            if (!ids.length) return;
            $scope.loading = true;
            $rootScope.showLinearProgress('#npvrLoader');

            $scope.modalWindowScope = $scope.$new();
            var inner = 'Are you sure you want to delete<b> ' + ids.length +'</b> records?';

            ModalWindowService.Open({
                content: inner,
                actions: [
                    {
                        title: 'I understand. Do it',
                        color: 'green',
                        fn: function () {
                            var reqList = [];
                            for(var i = 0; i < ids.length; i++) {
                                reqList.push(DVRTasksResource.remove({id: ids[i]}).$promise)
                            }
                            $q.all(reqList).then(function(values) {
                                $scope.loading = false;
                                $rootScope.hideLinearProgress('#npvrLoader');
                                ToastService.Small({
                                    title: 'The records were deleted',
                                    color: 'green',
                                    icon: 'delete'
                                });
                                $location.search('page', $scope.routePage);
                                $scope.getRecords();
                            }).catch(function(reason) {
                                $scope.loading = false;
                                $rootScope.hideLinearProgress('#npvrLoader');
                                $rootScope.debugInfo(reason);
                                ToastService.Small({
                                    title: 'Failed to remove records',
                                    color: 'red',
                                    icon: 'delete'
                                });
                            });
                        }
                    },
                    {
                        title: 'cancel',
                        color: 'red',
                        fn: function () {
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#npvrLoader');
                        }
                    }
                ],
                onComplete: function () {
                    $scope.modalWindowScope.$destroy();
                }
            });
        };

        $scope.openProgram = function (record) {
            if ($scope.loading) return;

            $scope.program = angular.copy(record);
            $scope.selectedStream = '';
            $scope.selectedStreamEscaped = '';
            $scope.selectedStreamType = 'hls';
            $scope.selectedStreamError = '';
            $scope.streamLoading = true;
            $scope.playAsUser = false;

            var licence = $location.protocol() + '://'+ $location.host() + '/discovery:80/sdp/v2/assets/'+record.live.id+'/wv-license?auth_token='+lh.common.config.get('authToken');
            $scope.license = licence.replace(/^http:\/\//,"https://");

            $scope.selectStreamAsAdmin = function() {
                if ($scope.program.state !== 'recorded') return;
                $scope.selectedStream = '';
                $scope.selectedStreamError = '';
                $scope.streamLoading = true;
                $scope.playAsUser = false;

                if ($scope.selectedStreamType === 'hls') {
                    $scope.getHLSStreamAsAdmin();
                } else {
                    $scope.getDASHStreamAsAdmin();
                }
            };

            $scope.getDASHStreamAsAdmin = function () {
                $scope.selectedStream = '';
                $scope.selectedStreamEscaped = '';
                $scope.selectedStreamType = 'dash';
                $scope.selectedStreamError = '';
                $scope.streamLoading = true;
                DVRTasksResource.getDashStream({ id: $scope.program.id }).$promise
                    .then(function (response) {
                        $scope.selectedStream = response.data;
                        $scope.selectedStreamEscaped = escape(response.data);
                        $scope.selectedStreamError = '';
                        $scope.streamLoading = false;
                    })
                    .catch(function (reason) {
                        $scope.streamLoading = false;
                        if (reason.data.error) {
                            $scope.selectedStreamError = reason.data.error;
                        }
                        $scope.selectedStream = '';
                        $rootScope.debugInfo(reason, 'silent');
                    })
            };

            $scope.getHLSStreamAsAdmin = function () {
                $scope.selectedStream = '';
                $scope.selectedStreamEscaped = '';
                $scope.selectedStreamType = 'hls';
                $scope.selectedStreamError = '';
                $scope.streamLoading = true;
                DVRTasksResource.getHLSStream({ id: $scope.program.id }).$promise
                    .then(function (response) {
                        $scope.selectedStream = response.data;
                        $scope.selectedStreamEscaped = escape(response.data);
                        $scope.selectedStreamError = '';
                        $scope.streamLoading = false;
                    })
                    .catch(function (reason) {
                        $scope.streamLoading = false;
                        if (reason.data.error) {
                            $scope.selectedStreamError = reason.data.error;
                        }
                        $scope.selectedStream = '';
                        $rootScope.debugInfo(reason, 'silent');
                    })
            };

            $scope.selectStreamAsUser = function() {
                if ($scope.program.state !== 'recorded') return;
                var clientId = '';
                for (var i=0; i < $rootScope._self.services.length; i++) {
                    var service = $rootScope._self.services[i];
                    if (service.instance && service.instance.platform && service.instance.platform.client_id) {
                        clientId = service.instance.platform.client_id;
                        break;
                    }
                }
                if (clientId === '') {
                    return;
                }

                return SubscriberV2Service.GetUserDeviceToken($scope.program._subscriber_ext_id, clientId)
                    .then(function (result) {
                        if (result.data) {
                            var token = result.data;
                            $scope.playAsUser = true;

                            DVRTaskService.GetStream($scope.program.id, token, $scope.selectedStreamType)
                                .then(function (response) {
                                    $scope.selectedStream = response.data;
                                    $scope.selectedStreamEscaped = escape(response.data);
                                    $scope.selectedStreamError = '';
                                    $scope.streamLoading = false;
                                })
                                .catch(function (reason) {
                                    $scope.streamLoading = false;
                                    if (reason.data.error) {
                                        $scope.selectedStreamError = reason.data.error.message;
                                    }
                                    $scope.selectedStream = '';
                                    $rootScope.debugInfo(reason, 'silent');
                                })
                        } else {
                            $scope.streamLoading = false;
                        }
                    })
                    .catch(function (reason) {
                        $scope.streamLoading = false;
                        $rootScope.debugInfo(reason, 'silent');
                    });

            };

            $scope.changeType = function(type) {
                $scope.selectedStreamType = type;
                if ($scope.playAsUser) {
                    $scope.selectStreamAsUser();
                } else {
                    $scope.selectStreamAsAdmin();
                }
            };

            $scope.selectStreamAsUser();

            var inner = $templateCache.get('npvr-record.tpl.html');
            inner = $compile(inner)($scope);

            $scope.window = ModalWindowService.Open({
                content: inner,
                isFixed: true,
                clear: true,
                keyboard: true,
                actions: [
                    {
                        title: 'Close',
                        color: 'red',
                        fn: function () {}
                    }
                ],
                size: {
                    s: 11,
                    l: 8
                }
            });
        };

        if (!_.isUndefined($routeParams.page) && $routeParams.page > 0) {
            $scope.routePage = Number($routeParams.page);
            $scope.collectionData.offset = ($scope.routePage - 1) * $scope.collectionData.limit;
        } else {
            $scope.routePage = 1;
        }

        $scope.getRecords();
        $scope.getStatData();

}]);
